import styled from 'styled-components';
import rmq from 'styled-rmq';

export default styled.a`
	position: absolute;
	top: 5rem;
	right: 5rem;
	text-decoration: none;
	background: rgba(80, 76, 215, 0.09);
	background: ${props => props.theme.wt};
	background: rgba(255, 255, 255, 0.15);
	background: ${props => props.theme.c2};
	color: ${props => props.theme.wt};
	padding: 0.5rem 1rem;
	border-radius: 0 0 0.25rem 0.25rem;
	z-index: 500;
	font-size: 1.3rem;
	transition: all 0.2s ease-in;
	text-transform: uppercase;
	font-family: ${props => props.theme.f2};

	&:hover {
		background: ${props => props.theme.c};
		color: ${props => props.theme.c1};
	}

	${rmq('700')} {
		top: 6rem;
	}
	${rmq('ls')} {
		right: 0;
	}
	${rmq('520')} {
		top: 5rem;
	}
	${rmq('440')} {
		top: 6rem;
	}
	${rmq('350')} {
		top: 7rem;
	}
	${rmq('ms')} {
		top: 0;
	}
`;
